import { Component, HostListener, OnInit } from '@angular/core';
import { PosService } from 'src/app/lazy/private/services/pos.service';
import { DialogComponent } from '../dialog/dialog.component';
import { DialogService } from '../dialog/dialog.service';

export interface PopUpModel {
  title: string;
}

@Component({
  selector: 'app-customer-list',
  templateUrl: './customer-list.component.html',
  styleUrls: ['./customer-list.component.css']
})
export class CustomerListComponent extends DialogComponent<PopUpModel, boolean>
  implements PopUpModel, OnInit {

  title: string;
  result: any = { result: false, RtnItem: {} };
  first = 0;
  rows = 10;
  customerSearch: string = ""
  list: any;
  selectedItem: any;
  cols: any;

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.keyCode == 40) {
      this.first = this.first + this.rows;
    }
    if (event.keyCode == 38) {
      this.first = this.first - this.rows;
    }
  }

  constructor(public dialogService: DialogService, private pos: PosService) {
    super(dialogService);
  }

  ngOnInit() {
    this.cols = [
      { field: 'Code', header: 'Code', f: 'text' },
      { field: 'Name', header: 'Customer Name', f: 'text' },
      { field: 'Mobile', header: 'Mobile No.', f: 'text' }
    ];
    this.getCustomerList()
  }

  getCustomerList() {
    this.pos.GetCustomer({ "Start": 0, "FiterText": this.customerSearch, "Limit": 100, "ItemTypeId": 1, "CAType": 1 })
      .subscribe(res => {
        if (res.Success) {
          this.list = res.data;
        }
      })
  }
  selectedCustomer(event) {
    this.result.result = true;
    this.result.RtnItem = this.selectedItem;
    this.close();
  }

}
